export default __webpack_public_path__ + "static/media/esim_change_format.f9e67aae.svg";